import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import LayoutResolver from './components/Layout/Resolver';
import './custom.css';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={<LayoutResolver element={element} rest={rest} />} />;
        })}
      </Routes>
    );
  }
}
